import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';

@Component({
  templateUrl: 'provider-info.modal.html'
})

export class ProviderInfoModalPage
{
  provider:any = {};

  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams
  ) {
    this.provider = this.navParams.get('editData');
  }

  dismissModal() {
    this.viewCtrl.dismiss();
  }
}  


// WEBPACK FOOTER //
// ./src/components/modals/provider-info.modal.ts